export default (measurementName, masterCategory, hmamContent, widthOverlay, coreMediaKey) => {
    const key = widthOverlay ? measurementName : measurementName || Object.keys(hmamContent)[0];
    const items = hmamContent[key][coreMediaKey];
    if (!items || !items.length) return false;

    const item = getItem(items, masterCategory);

    if (!item) return false;
    item.title = item.title || item.teaser?.teaserTitle;
    item.captionPlain = item.captionPlain || item.teaser?.teaserTextPlain;
    const pictures = item.media;
    if (pictures) {
        const { width, imageUrl, alt, height } = getItem(pictures, masterCategory) || {};
        item.width = width;
        item.imageUrl = imageUrl;
        item.alt = alt;
        item.height = height;
    }
    return item;
};

const getItem = (items, masterCategory) => {
    const masterCategoryIdentifiers = masterCategory?.map((cat) => cat.identifier);
    if (!masterCategoryIdentifiers) return false;
    return items.find((item) => {
        if (!Object.prototype.hasOwnProperty.call(item, 'tags')) return false;
        const productCategories = item.tags.find((tag) => tag.name === 'product-categories');
        // nice to be able to return early here, therefore using a standard for loop
        for (let i = 0, j = productCategories.children.length; i < j; i++) {
            if (masterCategoryIdentifiers.indexOf(productCategories.children[i].text) > -1) {
                return true;
            }
        }
    });
};
